import React, { Fragment, useState, useEffect } from 'react';
import { Table, Button, Spin} from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import { getDocLinks } from '../../../services/UserService';


const DocumentLinks = () => {
    const [docLinksData, setDocLinksData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchDocLinks = async () => {
        try {
            setLoading(true);
            const iec_no = localStorage.getItem('iec_no');
            const response = await getDocLinks(iec_no);
            if (response && response.data) {
                setDocLinksData(response.data);
            }
        } catch (error) {
            console.error("Error fetching document links:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDocLinks();
    }, []);

    const onLinkClick = (record) => {
        if (record.link) {
            window.open(record.link, '_blank');
        }
    };

    const columns = [
        {
            title: 'SRN',
            dataIndex: 'index',
            key: 'index',
            width: 70,
            render: (_, __, index) => index + 1,
        },
        {
            title: 'Type Name',
            dataIndex: 'type',
            key: 'type',
            width: 250,
        },
        {
            title: 'Link',
            dataIndex: 'link',
            key: 'link',
            width: 120,
            render: (_, record) => (
                <Button size="sm" variant="primary" onClick={() => onLinkClick(record)}>
                    Go to Page
                </Button>
            ),
        },
    ];

    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header>
                            <h4 className="card-title">Document Links</h4>
                        </Card.Header>
                        <Card.Body className="px-0">
                            {loading ? (
                                <div className="d-flex justify-content-center">
                                    <Spin />
                                </div>
                            ) : (
                                <Table
                                    bordered
                                    columns={columns}
                                    dataSource={docLinksData}
                                    rowKey={(record, index) => index}
                                    scroll={{ x: 'max-content' }}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default DocumentLinks;

